import { LessonType } from 'edrolo/enums/LessonType';
import { enums } from 'edrolo-ui';

interface PillMap {
  [key: string]: {
    iconName: enums.Icons;
    pillColor: enums.ColorHue | enums.ColorTheme;
    pillText: string;
  };
}

const pillMap: PillMap = {
  [LessonType.PRAC]: {
    iconName: enums.Icons.FLASK,
    pillColor: enums.ColorHue.AMBER,
    pillText: 'Prac',
  },
  [LessonType.VIDEO]: {
    iconName: enums.Icons.VIDEO_LESSON,
    pillColor: enums.ColorTheme.SECONDARY,
    pillText: 'Video Lesson',
  },
};

const defaultPillSpec = {
  iconName: enums.Icons.LESSON,
  pillColor: enums.ColorTheme.SECONDARY,
  pillText: 'Lesson',
};

export function getPillSpecs(category: LessonType) {
  return pillMap[category] || defaultPillSpec;
}
